export default function tableCarousel() {
    $('.table__prices').slick({
        infinite: false,
        slidesToShow: 3,
        centerMode: false,
        dots: false,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        responsive: [
            {
              breakpoint: 1120,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
              }
            },
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
              }
            },
        ]
    });
}
